import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');

export default function AppModal() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`appModalH5 ${css.appModalH5}`}>
            <div className="app-img">
                <EFPic name={['app.webp', 'app.jpg']} className="fullImgs" alt={t('presale.product.modals.app_learn')} />
            </div>
            <div className="texta-title1">{t('presale.product.modals.app')}</div>
            <div className="texta-title2">{t('presale.product.modals.app_learn')}</div>
            <div className="texta-title3">{t(locale === 'kr' ? 'presale.product.modals.app_des_h5' : 'presale.product.modals.app_des')}</div>
        </div>
    );
}
